import React from 'react';
import { BUDGET_COLORS } from '@/types/budgetColors';
import ColorPicker from '@/components/molecules/ColorPicker';

interface ColorSliderProps {
  title?: string;
  value?: string;
  onChange?: (color: string) => void;
  className?: string;
}

const ColorSlider: React.FC<ColorSliderProps> = ({ title, value = '', onChange, className = '' }) => {
  console.log('value', value);
  return (
    <div className={`mb-4 color-slider ${className}`}>
      <label className="inline-block text-[#495057] font-medium text-xs md:text-lg mb-2">{title}</label>
      <div className="relative mt-2 flex items-center gap-4">
        <ColorPicker value={value} onChange={onChange} />
      </div>
    </div>
  );
};

export default ColorSlider;
